<template>
  <div class="qrcode">
    <div class="flash" v-show="flash" @click="refresh">Click to update QR code</div>
    <Qrcode :size="size" cls="code" :value="qrcode"></Qrcode>
  </div>
</template>

<script>
  import Qrcode from 'v-qrcode/src/index'
  import axios from 'axios'
  import qs from 'qs'
  import CryptoJS from 'crypto-js'
  import { Message } from 'element-ui'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  import { ScanFlag } from '../common/GeneralVariable.js'
  import { getDeviceInfo, isGrayEnv, jumpToMainWeb, setLoginInfo } from '../common/utils.js'
  import { savePwd } from '../common/Common.js'
  import config from '@/assets/js/config.js'
  import Cipher from '../common/Cipher.js'
  export default {
    data () {
      return {
        randomcode: '',
        aeskey: 0,
        ti: 0,
        qrcode: '',
        size: 180,
        flash: false
      }
    },
    components: {
      Qrcode
    },
    mounted () {
      this.longPolling()
    },
    methods: {
      refresh () {
        this.flash = false
        this.longPolling()
      },
      // 创建qrcode
      createqrcode () {
        this.randomcode = new Date().getTime().toString() + this.rando(3)
        this.aeskey = this.rando(16)
        let qrcode = {
          'id': this.randomcode,
          'aeskey': this.aeskey,
          'platform': 'web'
        }
        this.qrcode = JSON.stringify(qrcode)
        this.ti++
      },
      // 生成一个随机数
      rando (m) {
        let num = ''
        for (let i = 0; i < m; i++) {
          let val = parseInt(Math.random() * 10, 10)
          if (i === 0 && val === 0) {
            i--
            continue
          }
          num += val
        }
        return num
      },
      // 长连方法
      longPolling () {
        this.createqrcode()
        axios({
          url: '/proxy-api/client/user/index/scan-login',
          params: {
            id: this.randomcode
          },
          method: 'post',
          timeout: 30000,
          responseType: 'json'
        }).then(async (result) => {
          let payload = result.data.payload
          let rpayload = payload.replaceAll('%2B', '+')
          let aeskeyhandle = CryptoJS.enc.Latin1.parse(this.aeskey)
          let decrypted = CryptoJS.AES.decrypt(rpayload, aeskeyhandle, {
            iv: aeskeyhandle,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          })
          let content = decrypted.toString(CryptoJS.enc.Utf8)
          content = JSON.parse(content)
          let email = content['email']
          let password = content['password']
          let privatekey = content['private_key']
          let publickey = content['public_key'] || ''
          let loginAccount = content['login_account'] || content['account_id'] || content['email']
          let type = content['type']
          savePwd(content, password)
          // 存入ls
//          localStorage.setItem(email + '_privatekey', privatekey)
//          if (publickey) {
//            localStorage.setItem(email + '_publickey', publickey)
//          }

          // 登录
          let data = {}
          if (type === 1) {
            if (privatekey) {
              localStorage.setItem(loginAccount + '_privatekey', privatekey)
            }
            if (publickey) {
              localStorage.setItem(loginAccount + '_publickey', publickey)
            }
            data = {
              phone_md5: CryptoJS.MD5(loginAccount).toString().substr(8, 16),
              password_hash: Cipher.RSAencrypt(config.pwdPublicKey, password),
              decrypt_type: 2,
              // 此cryptojs版本有bug，需要tostring转换一下
              key_md5: CryptoJS.MD5(publickey).toString().substr(8, 16)
            }
          } else if (type === 0) {
            email = loginAccount || email
            if (privatekey) {
              localStorage.setItem(email + '_privatekey', privatekey)
            }
            if (publickey) {
              localStorage.setItem(email + '_publickey', publickey)
            }
            data = {
              email: email,
              password_hash: Cipher.RSAencrypt(config.pwdPublicKey, password),
              decrypt_type: 2,
              // 此cryptojs版本有bug，需要tostring转换一下
              key_md5: CryptoJS.MD5(publickey).toString().substr(8, 16)
            }
          } else if (type === 2) {
            if (privatekey) {
              localStorage.setItem(loginAccount + '_privatekey', privatekey)
            }
            if (publickey) {
              localStorage.setItem(loginAccount + '_publickey', publickey)
            }
            data = {
              account_id: loginAccount,
              password_hash: Cipher.RSAencrypt(config.pwdPublicKey, password),
              decrypt_type: 2,
              key_md5: CryptoJS.MD5(publickey).toString().substr(8, 16)
            }
          }
          if (!localStorage.getItem('pcVersion')) {
            data['useragent'] = 'web'
          } else {
            data['useragent'] = localStorage.getItem('pcVersion')
          }

          // data add scan login flag.
          data['is_scan'] = ScanFlag.IS_SCAN_LOGIN
          // add device info.
          let deviceInfo = await getDeviceInfo()
          data['device_name'] = deviceInfo.deviceName
          data['device_id'] = deviceInfo.deviceId
          data['temporary_gray'] = isGrayEnv()

          this.login(data, loginAccount, type)
        }).catch((XMLHttpRequest, textStatus, errorThrown) => {
          if (this.$route.path === '/login/scan') {
            if (this.ti < 3) {
              this.longPolling()
              this.ti++
            } else {
              this.flash = true
            }
          }
        })
      },
      setAccountToLocal (loginAccount) {
        let obj = {}
        let arr = []
        obj[loginAccount] = ''
        arr.push(obj)
        localStorage.setItem('passwords', JSON.stringify(arr))
      },
      // 登录方法
      async login (data, loginAccount, type) {
        axios.post('/proxy-api/client/user/index/web-login', qs.stringify(data))
        .then((result) => {
          // 埋点统计：登录扫码登录结果
          uploadWebEvent('SIGNIN_SCAN_RESULT', {
            type,
            status: result.data.status
          })
          if (result.data.status === '0') {
            let passwords = localStorage.getItem('passwords')
            if (passwords && JSON.parse(passwords).length !== 0) {
              let account = Object.keys(JSON.parse(passwords)[0])[0]
              if (account !== loginAccount) {
                this.setAccountToLocal(loginAccount)
              }
            } else {
              this.setAccountToLocal(loginAccount)
            }
            setLoginInfo(result.data.payload)
            jumpToMainWeb(result.data.payload['is_gray'])
            // location.href = '../web/index.html'
          } else {
            Message({
              message: result.data.msg,
              type: 'error'
            })
            console.error(result.data.msg)
            this.flash = true
          }
        })
        .catch((error) => {
          Message({
            message: 'Oops, an unexpected error occurred. Please try again.',
            type: 'error'
          })
          console.error(error)
          this.flash = true
        })
      }
    }
  }
</script>

<style lang="less" scoped>
	.qrcode {
    width: 100%;
    height: 145px;
    margin-top: 40px;
    padding-left: 138px;
    .flash {
      width: 167px;
      height: 167px;
      position: absolute;
      background: rgba(255,255,255,0.9);
      color: #000;
      text-align: center;
      line-height: 167px;
      font-size: 14px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// Qrcode.vue?5d8b3d7e